<template>
    <div class="container">
      <div class="border">
        <img src="/static/img/acCleaning/image/Beneat.png" class="qrcode">
        <div class="text">
          <p>หรือดาวน์โหลด </p>
          <p class="beneat">BeNeat</p>
          <p>Application</p>
        </div>
        <div v-if="false" class="text">
          <p>พร้อมรับส่วนลด</p>
          <p class="discount">10%</p>
          <p>ทันที</p>
        </div>
        <div class="download">
          
          <a href="https://itunes.apple.com/th/app/beneat/id1203611695?mt=8" target="_blank">
            <img src="/static/img/acCleaning/image/AppStore.png" alt="Line BeNeat" class="img">
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.beneat.app" target="_blank">
            <img src="/static/img/acCleaning/image/GooglePlay.png" alt="Line BeNeat" class="img">
          </a>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DownloadSection'
  }
  </script>
  
  <style lang="scss" scoped>
  @import '../../../static/sass/page/ac_cleaning.scss';
  
  .container {
    margin: 5% 0;
    place-items: center;
  }
  
  .border {
    margin: 0;
    padding: 30px;
    background-color: #F5F5F5;
    place-items: center;
    text-align: center;
    width: 100%;
  }
  
  .text {
    margin: 0;
    font-size: 18px;
    font-weight: 400;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
  }
  
  p {
    margin: 0;
  }
  
  .beneat {
    color: $secon-color;
  }
  
  .discount {
    color: #E89A54;
  }
  
  .download {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    gap: 0px;
  }
  
  .qrcode {
    width: 107px;
    height: 107px;
    margin-bottom: 16px;
  }
  
  .img {
    cursor: pointer;
  }
  
  @media (min-width: 375px) {
    .download {
      gap: 20px;
    }
  }
  
  @media (min-width: 1024px) {
    .border {
      width: fit-content;
      border-radius: 14px;
      padding: 30px;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/acCleaningRe/DownloadBeNeatApp.vue